module.exports = __webpack_public_path__ + "img/headerbg.2b79d269.png";